import { render, staticRenderFns } from "./TransferCenterDonePayments.vue?vue&type=template&id=148794f4&scoped=true"
import script from "./TransferCenterDonePayments.vue?vue&type=script&lang=js"
export * from "./TransferCenterDonePayments.vue?vue&type=script&lang=js"
import style0 from "./TransferCenterDonePayments.vue?vue&type=style&index=0&id=148794f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148794f4",
  null
  
)

export default component.exports